const VARIANTS = {
  neutral: 'bg-white/[0.06] text-white border-white/10 hover:bg-white/[0.1]',
  danger: 'bg-red-500/15 text-red-400 border-red-500/30 hover:bg-red-500/25',
  primary: 'bg-primary/20 text-primary border-primary/40 hover:bg-primary/30',
};

export const RoundButton = ({ variant = 'neutral', children, className = '', ...props }) => (
  <button
    type="button"
    className={`h-[68px] w-[68px] rounded-full border text-sm font-semibold transition-[background-color,transform,opacity] duration-200 active:scale-95 disabled:opacity-30 disabled:pointer-events-none ${VARIANTS[variant]} ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default RoundButton;
